import { motion } from "framer-motion";
import { services } from "@/data/projects";

const EASE = [0.25, 0.1, 0.25, 1];

const chapters = [
  {
    n: "01",
    t: "Clarity",
    b: "We reduce each brief to its essential geometry — spaces that are legible, calm and unforced.",
  },
  {
    n: "02",
    t: "Context",
    b: "Every project is rooted in its site and cultural memory, from the Falaj channel to the classical court.",
  },
  {
    n: "03",
    t: "Experience",
    b: "Material, light and proportion are composed for how a space is actually lived and remembered.",
  },
];

export default function Practice() {
  return (
    <section
      id="practice"
      className="relative z-10 scroll-mt-24 border-t border-[#e4e4e2] bg-white"
      data-testid="practice-section"
    >
      <div className="mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-40">
        <span className="ama-label text-[#1B3818]">The Practice</span>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15% 0px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mt-10 max-w-5xl text-3xl font-light leading-[1.12] tracking-tight md:text-6xl"
        >
          Designing architecture that balances clarity, context and experience.
        </motion.h2>

        {/* Manifesto chapters */}
        <div className="mt-24 grid grid-cols-1 gap-px border border-[#e4e4e2] bg-[#e4e4e2] md:grid-cols-3">
          {chapters.map((c) => (
            <div key={c.n} className="bg-white p-8 md:p-12">
              <div className="flex items-baseline justify-between">
                <span className="mono-num ama-label text-[#1B3818]">{c.n}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-[#1B3818]" />
              </div>
              <h3 className="mt-8 text-2xl font-light tracking-tight md:text-3xl">
                {c.t}
              </h3>
              <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-black/55">
                {c.b}
              </p>
            </div>
          ))}
        </div>

        {/* Services */}
        <div className="mt-28 border-t border-[#e4e4e2] pt-10">
          <span className="ama-label text-black/45">Disciplines</span>
          <div className="mt-10 grid grid-cols-1 gap-px bg-[#e4e4e2] md:grid-cols-2">
            {services.map((s) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, ease: EASE }}
                className="group flex items-start gap-6 bg-white p-8 md:p-14"
                data-testid={`service-${s.index}`}
              >
                <span className="mono-num ama-label pt-2 text-black/30 transition-colors duration-500 group-hover:text-[#1B3818]">
                  {s.index}
                </span>
                <div>
                  <h3 className="text-2xl font-light tracking-tight md:text-4xl">
                    {s.title}
                  </h3>
                  <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-black/55">
                    {s.body}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
